export class AzureSqlDatabaseNativePitrBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "AzureSqlDatabaseNativePitrBackupResourceType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlDatabaseNativePitrBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
